<template>
  <div class="title-box">
    <h2 class="title-box_title">{{ title }}</h2>
    <div class="title-box_right">
      <div class="title-box_right-content">
        <Tag
          class="tag--public"
          :class="{ 'tag--selected': i.selected }"
          v-for="i in tagsData"
          :key="i.id"
          :value="i.title"
          @click="$emit('changeFilter', i)"
        />
      </div>
      <div class="divider divider--vertical"></div>
      <div class="title-box_right-content">
        <PublicSelect
          style="min-width: 240px"
          :items="sortData"
          :selected="selectedSort"
          @input="$emit('sortChange', $event)"
        ></PublicSelect>
      </div>
    </div>
  </div>
</template>

<script>
import PublicSelect from "@/components/inputs/PublicSelect.vue";
import Tag from "@/components/Tag.vue";

export default {
  components: { Tag, PublicSelect },
  props: {
    title: { type: String, required: true },
    tagsData: { type: Array, required: true },
    sortData: { type: Array, required: true },
    selectedSort: { type: String, required: true },
  },
};
</script>

<style lang="scss" scoped>
.title-box {
  @include titleFlexWrapper;

  &_right {
    @include rightActionsWrapper();
  }
  &_title {
    font-size: 5.2rem;
    line-height: 1.25;
    @media screen and (max-width: $md) {
      font-size: 35px;
    }
  }
}
</style>

